<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-card class="login" flat style="border-radius: 10px; padding: 10px;">
              <span class="login-title" style="padding: 10px">
                <img src="../../assets/logoGiftList.png" width="100%" style="max-width: 150px">
              </span>
              <v-card-text style="padding: 0px">
                <v-stepper v-model="stepper">
                  <v-stepper-header>
                    <v-stepper-step :complete="stepper > 1" step="1" color="#5b3a4b">Informações</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="stepper > 2" step="2" color="#5b3a4b">Organizador</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="3" color="#5b3a4b">Acesso</v-stepper-step>
                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-card flat>
                        <v-row>
                          <v-col cols="12">
                            <v-autocomplete
                              :items="categorias"
                              item-text="descricao"
                              item-value="id"
                              label="Selecione a categoria de seu evento"
                              outlined
                              hide-details
                              color="#5b3a4b"
                              v-model="categoriaSelecionada"
                              @change="carregaPresentes"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              :items="produtos"
                              item-text="descricao"
                              item-value="id"
                              label="Selecione quais presentes deseja receber"
                              outlined
                              hide-details
                              color="#5b3a4b"
                              :disabled="categoriaSelecionada == ''"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" style="padding: 8px 0px 8px 0px" @click="stepper = 2">Continuar</v-btn>
                        </v-card-actions>
                      </v-card>
                      
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-card flat>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              :label="nomeCategoria(categoriaSelecionada) == 'Casamento' ? 'Nome dos noivos' : 'Nome do organizador'"
                              color="#5b3a4b"
                              outlined
                              hide-details
                              v-model="empresa.nome"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" v-if="nomeCategoria(categoriaSelecionada) == 'Aniversário'">
                            <v-text-field
                              label="Idade"
                              color="#5b3a4b"
                              outlined
                              hide-details
                              type="tel"
                              v-model="empresa.idade"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="Título (será exibido na página de confirmação)"
                              color="#5b3a4b"
                              outlined
                              hide-details
                              type="tel"
                              v-model="empresa.titulo"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <!-- campo para foto do convite -->
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="Descrição"
                              color="#5b3a4b"
                              outlined
                              hide-details
                              type="tel"
                              v-model="empresa.titulo"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="Telefone"
                              color="#5b3a4b"
                              outlined
                              hide-details
                              type="tel"
                              v-mask="'(##) #####-####'"
                              v-model="empresa.telefone"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="E-mail"
                              color="#5b3a4b"
                              outlined
                              hide-details
                              type="mail"
                              v-model="empresa.email"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" style="padding: 8px 0px 8px 0px" @click="stepper = 3">Continuar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card>
                      <v-btn color="primary" @click="stepper = 1">Continue</v-btn>
                      <v-btn text>Cancel</v-btn>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  /* import vueCard from 'vue-card-express'; */
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl, /* modelBoleto */ } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import {
    mapState
  } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    components: { Snackbar, Loading },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        isLoading: false,
        fullPage: true,
        empresa: {
          nome: '',
          cnpj: '',
          endereco: '',
          telefone: '',
          email: '',
          descricao: '',
          data: '',
          horario: '',
          imagemUrl: '',
          listaPresentes: null
        },
        stepper: 1,
        categorias: [],
        produtos: [],
        categoriaSelecionada: '',
        dictionary: {
          custom: {
            nomeCartao: {
              required: () => 'Informe o nome'
            },
            numCartao: {
              required: () => 'Informe o número do cartão de crédito',
            },
            cpftitular: {
              required: () => 'Informe o número do cartão de crédito',
            },
            codCartao: {
              required: () => 'Informe o código de segurança'
            },
            expiraCartaoMes: {
              required: () => 'Informe o mês de validade do cartão',
            },
            expiraCartaoAno: {
              required: () => 'Informe o ano de validade do cartão',
            },
            dateOfBirth: {
                required: () => 'Informe a Data de Nascimento' ,
                date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
            },
          }
        }
      }
    },
    
    mounted: function () {
      this.carregaCategorias()
      this.$validator.localize('pt', this.dictionary)
    },

    methods: {
      async carregaCategorias() {
        await axios.get(baseApiUrl + 'Categorias?filter={"where":{"empresaId":"NOVO CADASTRO"}, "order": "descricao ASC"}')
        .then(response => {
          if (response.data.length > 0) {
            this.categorias = response.data
          }
        })
      },

      async carregaPresentes() {
        await axios.get(baseApiUrl + 'Produtos?filter={"where":{"categoriaId":"' + this.categoriaSelecionada + '"}}')
        .then(response => {
          if (response.data.length > 0) {
            this.produtos = response.data
          }
        })
      },

      nomeCategoria(categoriaId) {
        let nomeCategoria
        this.categorias.filter(categoria => {
          if (categoria.id === categoriaId) {
            nomeCategoria = categoria.descricao
          }
        })
        return nomeCategoria
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to left, #e8bf9f, #5b3a4b);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  a {
    text-decoration: none
  }
</style>
